import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Switch, Route } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { login } from "../../../actions";

import LoginForm from "./LoginForm";

function LoginContainer() {

	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { status, error } = useSelector(state => state.auth);
	const [statusAlert, setStatusAlert] = React.useState(null);

	const _handleLogin = (values) => {
		dispatch(login(values));
	}

	React.useEffect(() => {
		switch (status) {
			case "loggedOut":
				setStatusAlert(
					<Alert variant="info">{t('auth.youveBeenLoggedOut')}.</Alert>
				);
				break;
			case "loginFailed":
				setStatusAlert(
					<Alert variant="warning">
						{error && error.code && error.code === 0
							? error.details
							: t('auth.loginFailedWithCredentials')}.
					</Alert>
				);
				break;
			default:
				setStatusAlert(null);
		}
	}, [status, error, t]);

	return (
		<React.Fragment>
			<h1 style={{marginBottom: '10px' }}> {t('auth.login')}</h1>

			<hr />

			{statusAlert}

			<Switch>
				<Route path="/password-recovery">
					<div>{t('auth.passwordRecovery')}</div>
				</Route>
				<Route path="/">
					<LoginForm
					onSubmit={_handleLogin}
					status={status}
					error={error}
				/>
				</Route>
			</Switch>

			<hr />

			<NavLink to={`password-recovery`}>{t('auth.forgotYourPasswordTitle')}?</NavLink>
		</React.Fragment>
	);
}

export default LoginContainer;
